/**
 * page-flip — 翻頁手勢／索引計算（**純函數**；Node 可直接 import → `scripts/ui-smoke.mjs` 真測）
 *
 * 為何要（`decisions/027` 批次 B）：產品負責人要求第 2 個 tab ＝**日記簿**，「flip left to right and
 *   right to left」。手勢判定同索引夾位最易出錯（例如斜掃誤觸、撳到盡仲有箭嘴）→ 抽做純函數。
 *   ⚠️ 刻意**唔循環**（到頭／到尾就停）：日記唔應該「撳多一下就返到第一頁」。
 */

/** 掃一下嘅判定結果：`-1` ＝ 上一頁（向左掃／內容右移）、`1` ＝ 下一頁、`0` ＝ 唔算（唔夠力／太斜） */
export function flipDirection(dx: number, dy: number, threshold = 48): number {
  if (!Number.isFinite(dx) || !Number.isFinite(dy)) return 0;
  const ax = Math.abs(dx);
  const ay = Math.abs(dy);
  /** 唔夠遠 → 唔算（防誤觸） */
  if (ax < threshold) return 0;
  /** 太斜（多數係上下捲）→ 唔算 */
  if (ax < ay * 1.5) return 0;
  /** 手指向左移（dx < 0）＝ 想睇**下一頁** */
  return dx < 0 ? 1 : -1;
}

/** 夾住索引（唔循環；空 ＝ -1） */
export function clampPage(length: number, index: number): number {
  if (!Number.isFinite(length) || length <= 0) return -1;
  const i = Number.isFinite(index) ? index : 0;
  return Math.min(Math.max(i, 0), length - 1);
}

/** 加減頁數（夾位；唔循環） */
export function stepPage(length: number, index: number, delta: number): number {
  const i = clampPage(length, index);
  if (i < 0) return -1;
  return Math.min(Math.max(i + delta, 0), length - 1);
}

/** 頁碼文字（`3 / 12`；冇頁 ＝ `-`） */
export function pageLabel(index: number, length: number): string {
  const i = clampPage(length, index);
  return i < 0 ? '-' : `${i + 1} / ${length}`;
}
